import { computed } from "vue";

/** ===== Client Type ===== */
const CLIENT_TYPE_LABELS = {
  ar: {
    entrepreneur: "ريادي",
    startup: "شركة ناشئة",
    small_business: "منشأة صغيرة",
  },
  en: {
    entrepreneur: "Entrepreneur",
    startup: "Startup",
    small_business: "Small Business",
  },
};

export function useClientTypeLabel(clientTypeRef, langRef, opts = {}) {
  const fallback = opts.fallback ?? "";

  return computed(() => {
    const lang = String(langRef?.value || "ar")
      .toLowerCase()
      .startsWith("en")
      ? "en"
      : "ar";

    const key = String(clientTypeRef?.value || "").trim();
    if (!key) return fallback;

    return CLIENT_TYPE_LABELS[lang]?.[key] || key || fallback;
  });
}

export function useClientTypeIcon(clientTypeRef) {
  return computed(() => {
    const key = String(clientTypeRef?.value || "").toLowerCase();

    if (key === "entrepreneur") return "mdi-lightbulb-on-outline";
    if (key === "startup") return "mdi-rocket-launch-outline";
    if (key === "small_business") return "mdi-store-outline";
    return "mdi-briefcase-outline";
  });
}

/** ===== Consultant Type ===== */
const CONSULTANT_TYPE_LABELS = {
  ar: {
    individual: "فرد",
    office: "مكتب",
  },
  en: {
    individual: "Individual",
    office: "Office",
  },
};

export function useConsultantTypeLabel(consultantTypeRef, langRef, opts = {}) {
  const fallback = opts.fallback ?? "";

  return computed(() => {
    const lang = String(langRef?.value || "ar")
      .toLowerCase()
      .startsWith("en")
      ? "en"
      : "ar";

    const key = String(consultantTypeRef?.value || "").trim();
    if (!key) return fallback;

    return CONSULTANT_TYPE_LABELS[lang]?.[key] || key || fallback;
  });
}

export function useConsultantTypeIcon(consultantTypeRef) {
  return computed(() => {
    const key = String(consultantTypeRef?.value || "").toLowerCase();

    if (key === "individual") return "mdi-account-outline";
    if (key === "office") return "mdi-office-building-outline";
    return "mdi-account-badge-outline";
  });
}
